import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import wb from "./registerServiceWorker";
import "./assets/styles.scss";
import "./vee-validate";

Vue.config.productionTip = false;
Vue.prototype.$workbox = wb;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
